export default __webpack_public_path__ + "static/media/cloud-upload.3c76724d.webp";